export default class Timer {
  timerId: number
  start: number
  remaining: number
  callback: Function

  constructor(callback: Function, delay: number) {
    this.callback = callback
    this.remaining = delay
    this.timerId = setTimeout(this.callback, this.remaining)
    this.start = new Date().getTime()
  }

  pause(): void {
    clearTimeout(this.timerId)
    this.remaining -= new Date().getTime() - this.start
  }

  resume(): void {
    clearTimeout(this.timerId)
    this.timerId = setTimeout(this.callback, this.remaining)
    this.start = new Date().getTime()
  }
}
